import { useEffect, useState } from 'react';
import { sendReceipt } from './chatApi';

const flushDelayMs = 1500;
const positions = new Map();

// Докъде това устройство е получило / показало съобщенията на всеки чат. Праща се най-много веднъж на 1,5 сек. и само
// ако позицията е напреднала — не на всяко съобщение.
const report = (chatId, delivered, read) => {
  const position = positions.get(chatId) || {
    delivered: 0,
    read: 0,
    sentDelivered: 0,
    sentRead: 0,
    timer: null,
  };
  position.delivered = Math.max(position.delivered, delivered, read);
  position.read = Math.max(position.read, read);
  positions.set(chatId, position);

  const ahead = position.delivered > position.sentDelivered || position.read > position.sentRead;
  if (position.timer || !ahead) return;

  position.timer = setTimeout(() => {
    position.timer = null;
    const body = { deliveredUpTo: position.delivered, readUpTo: position.read };
    sendReceipt(chatId, body)
      .then(() => {
        position.sentDelivered = Math.max(position.sentDelivered, body.deliveredUpTo);
        position.sentRead = Math.max(position.sentRead, body.readUpTo);
      })
      .catch(() => true);
  }, flushDelayMs);
};

const reportDelivered = (chatId, messageId) => messageId && report(chatId, messageId, 0);

const reportRead = (chatId, messageId) => messageId && report(chatId, messageId, messageId);

// „Видяно" — само докато табът / таблетът е на преден план.
const usePageVisible = () => {
  const [visible, setVisible] = useState(document.visibilityState === 'visible');
  useEffect(() => {
    const onChange = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);
  return visible;
};

const upsertReceipt = (receipts, receipt) => [
  ...receipts.filter(x => !(x.userId === receipt.userId && x.readerType === receipt.readerType)),
  receipt,
];

// Статус на мое съобщение: „видяно" / „получено", щом поне един от другата страна е стигнал до него.
const messageStatus = (message, receipts, otherReaderType) => {
  if (!message.id) return null;
  const others = receipts.filter(x => x.readerType === otherReaderType);
  const seenBy = others.filter(x => x.lastReadMessageId >= message.id);
  if (seenBy.length) return { state: 'seen', names: seenBy.map(x => x.userName).filter(Boolean) };
  if (others.some(x => x.lastDeliveredMessageId >= message.id)) return { state: 'delivered' };
  return { state: 'sent' };
};

export { reportDelivered, reportRead, usePageVisible, upsertReceipt, messageStatus };
